<template>
	<div>
		
		<v-card>
			<v-card-title class="py-2 primary">
				<span class="tertiary--text">
					{{ action == 'store' ? 'Aggiungi Accordo' : (action == 'edit' ? 'Modifica Accordo' : 'Visualizza Accordo') }}
				</span>
			</v-card-title>
			<v-card-text class="pt-6">
				<v-form ref="accordoForm">
					<v-row>
						<v-col>
							<v-autocomplete
								:items="clienti"
								item-text="ragione_sociale"
								item-value="id"
								v-model="accordo.cliente_id"
								label="Cliente"
								:rules="[mixin_rules.required]"
								:loading="isLoadingClienti"
								:disabled="isLoading || action == 'edit' || clienteId !== null"
								:readonly="action == 'show'"
								outlined
								dense
							></v-autocomplete>
						</v-col>
						<v-col>
							<v-select
								:items="accountManagers"
								item-value="id"
								v-model="accordo.account_manager_id"
								label="Account Manager"
								dense
								outlined
								:loading="isLoadingAccountManagers"
								:disabled="isLoadingAccountManagers"
								:readonly="action == 'show'"
								:rules="[mixin_rules.required]"
							>
								<template v-slot:item="{ item, attrs, on }">
									<v-list-item v-on="on" v-bind="attrs">
										<v-list-item-content>
											<v-list-item-title>
												{{ item.nome }} {{ item.cognome }}
											</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</template>
								<template v-slot:selection="{ item }">
									{{ item.nome }} {{ item.cognome }}
								</template>
							</v-select>
						</v-col>
					</v-row>
					
					<v-row class="mt-0">
						<v-col>
							<v-select
								:items="bandi"
								item-text="nome"
								item-value="id"
								v-model="accordo.bando_id"
								label="Bando"
								dense
								outlined
								:rules="[mixin_rules.required]"
								:loading="isLoadingBandi"
								disabled
							></v-select>
							<!--:disabled="isLoading || action == 'edit'"-->
							<!--:readonly="action == 'show'"-->
						</v-col>
						<v-col>
							<v-text-field
								v-model.number="accordo.numero_pratiche"
								label="Numero pratiche"
								type="number"
								min="1"
								outlined
								dense
								:disabled="isLoading || action == 'edit'"
								:readonly="action == 'show'"
								:hint="(action == 'edit' || action == 'show')
									? null
									: `Verranno generate ${accordo.numero_pratiche || 0 } pratiche`"
								persistent-hint
								:rules="[mixin_rules.min0]"
							></v-text-field>
						</v-col>
					</v-row>
					
					<v-row class="mt-0">
						<v-col cols="6">
							<v-select
								v-model="accordo.tipo_di_fatturazione"
								:items="tipiDiFatturazione"
								label="Tipo di Fatturazione"
								:loading="isLoadingTipiDiFatturazione"
								:disabled="isLoadingTipiDiFatturazione"
								:readonly="action == 'show'"
								outlined
								dense
							></v-select>
						</v-col>
						<v-col>
							<v-text-field
								v-model="accordo.link_affare"
								label="Link affare"
								outlined
								dense
								:readonly="action == 'show'"
							></v-text-field>
						</v-col>
					</v-row>
					
					<v-row class="mt-0">
						<v-col>
							<template v-if="action == 'store' || action == 'edit'">
								<v-file-input
									v-model="files.accordo_prenotazione"
									label="Accordo di Prenotazione"
									outlined
									dense
									clearable
									accept=".pdf"
									:loading="isLoadingAccordoPrenotazione"
									:disabled="isLoadingAccordoPrenotazione || senzaAccordo"
									truncate-length="100"
									@change="setChanged(files.accordo_prenotazione)"
									@click:clear="accordo.path_accordo_prenotazione = null"
									:rules="[accordoFileRules]"
								>
									<template
										v-slot:append
										v-if="files.accordo_prenotazione !== null"
									>
										<v-icon
											class="ml-3"
											@click="viewFileInBrowser(files.accordo_prenotazione)"
										>
											mdi-eye-outline
										</v-icon>
									</template>
								</v-file-input>
							</template>
							<template v-else-if="action == 'show'">
								<v-text-field
									:value="getFileNameFromPath(accordo.path_accordo_prenotazione)"
									label="Accordo prenotazione"
									outlined
									dense
									readonly
								>
									<template
										v-slot:append
										v-if="accordo.path_accordo_prenotazione !== null && !isLoadingAccordoPrenotazione"
									>
										<v-progress-circular
											v-if="isGettingFile.accordo_prenotazione"
											size="24"
											width="3"
											color="primary"
											indeterminate
											class="ml-3"
										></v-progress-circular>
										<v-icon
											v-else
											class="ml-3"
											@click="getFileAndViewInBrowser(accordo.path_accordo_prenotazione, 'accordo_prenotazione')"
										>
											mdi-eye-outline
										</v-icon>
									</template>
								</v-text-field>
							</template>
						</v-col>
					</v-row>
					<v-row class="mt-0">
						<v-col>
							<v-checkbox
								v-model="senzaAccordo"
								label="Senza Accordo"
								color="primary"
								hide-details
								:readonly="action == 'show'"
								:disabled="isLoadingAccordoPrenotazione || files.accordo_prenotazione !== null"
								class="mt-0"
							></v-checkbox>
						</v-col>
						<v-col>
							<v-checkbox
								v-model="accordo.is_gold"
								label="Gold"
								color="primary"
								hide-details
								:readonly="action == 'show'"
								class="mt-0"
							></v-checkbox>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<v-text-field
								v-model="accordo.nome_referente"
								label="Nome Referente"
								outlined
								dense
								:readonly="action == 'show'"
								autocomplete="none"
							></v-text-field>
						</v-col>
						<v-col>
							<v-text-field
								v-model="accordo.cognome_referente"
								label="Cognome Referente"
								outlined
								dense
								:readonly="action == 'show'"
								autocomplete="none"
							></v-text-field>
						</v-col>
					</v-row>
					<v-row class="mt-0">
						<v-col cols="6">
							<v-text-field
								v-model="accordo.email_referente"
								label="Email Referente"
								outlined
								dense
								:readonly="action == 'show'"
								autocomplete="none"
								:rules="[mixin_rules.email]"
							></v-text-field>
						</v-col>
						<v-col cols="6">
							<v-text-field
								:value="accordo.cliente?.email"
								label="Email Cliente"
								:loading="isLoadingCliente"
								outlined
								dense
								readonly
								autocomplete="none"
							></v-text-field>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-btn
					v-if="isAccountManager && action == 'edit'"
					color="secondary"
					@click="openNotesDialog()"
				>
					Note Accordo
				</v-btn>
				<v-spacer></v-spacer>
				<v-btn
					color="tertiary"
					@click="close()"
					:disabled="isSaving"
					class="black--text"
				>
					{{ action == 'show' ? 'Chiudi' : 'Annulla'}}
				</v-btn>
				<v-btn
					v-if="action == 'store' || action == 'edit'"
					color="secondary"
					@click="action == 'store' ? store() : (action == 'edit' ? update() : null)"
					:loading="isSaving"
					:disabled="isLoading || isSaving"
				>
					Salva
				</v-btn>
			</v-card-actions>
			
			<v-dialog
				v-model="notesDialog"
				persistent
				max-width="700"
				scrollable
			>
				<accordo-notes
					v-if="action == 'edit'"
					:key="notesKey"
					v-model="accordo"
					@close="notesDialog = false"
				></accordo-notes>
			</v-dialog>
		</v-card>
	
	</div>
</template>

<script>
import { eventBus } from "@/event-bus";
import {mapActions, mapGetters} from "vuex";

export default {
	props: {
		value: {
			default: null
		},
		action: {
			default: null
		},
		clienteId: { // dialog con gli accordi di un cliente
			default: null
		}
	},
	data() {
		return {
			isLoadingBandi: false,
			isLoadingClienti: false,
			isLoadingAccordoPrenotazione: false,
			isLoadingAccountManagers: false,
			clienti: [],
			bandi: [],
			accordo: {},
			accountManagers: [],
			files: {
				accordo_prenotazione: null
			},
			senzaAccordo: false,
			isLoadingTipiDiFatturazione: false,
			tipiDiFatturazione: [],
			isSaving: false,
			
			notesKey: 0,
			notesDialog: false,
			
			isLoadingCliente: false
		}
	},
	
	async created() {
		this.accordo = Object.assign({}, this.value || this.accordoVoid);
		this.accordo.bando_id = this.bando?.id;
		this.getBandi();
		this.getTipiDiFatturazione();
		this.getAccountManagers();
		if (this.accordo.path_accordo_prenotazione !== null && this.action != 'show') {
			this.getAccordoPrenotazione();
		}
		if (this.action == 'edit') {
			if (this.accordo.path_accordo_prenotazione === null) this.senzaAccordo = true;
		}
		if (this.action == 'store') this.accordo.account_manager_id = this.user.account_manager.id;
		
		// devo attendere di ricevere i clienti perché mi servono successivamente
		await this.getClienti();
		if (this.clienteId) {
			this.accordo.cliente_id = this.clienteId;
			this.accordo.cliente = this.clienti.find(cliente => cliente.id == this.clienteId);
		}
		
		this.$watch('accordo.cliente_id', (newClienteId, oldClienteId) => {
			if (newClienteId != oldClienteId && newClienteId !== null) {
				this.accordo.cliente = this.clienti.find(cliente => cliente.id == newClienteId);
			}
		});
	},
	
	computed: {
		...mapGetters({
			isAccountManager: 'auth/isAccountManager',
			user: 'auth/user',
			bando: 'shared/bando'
		}),
		isLoading() {
			return this.isLoadingClienti
				|| this.isLoadingBandi
				|| this.isLoadingAccordoPrenotazione
				|| this.isLoadingAccountManagers;
		},
		accordoFileRules() {
			return this.senzaAccordo ? true : this.mixin_rules.fileRequired
		}
	},
	
	methods: {
		...mapActions({
			showSnackbar: 'systemSnackbar/show',
			// getFile: 'storage/getFile',
			// apriPdfInUnaNuovaSchedaDelBrowser: 'storage/apriPdfInUnaNuovaSchedaDelBrowser'
		}),
		getClienti() {
			this.isLoadingClienti = true;
			return axios.get('/api/clienti?order_by=ragione_sociale')
				.then(response => {
					this.clienti = response.data;
				})
				.finally(() => {
					this.isLoadingClienti = false;
				})
		},
		getBandi() {
			this.isLoadingBandi = true;
			axios.get('/api/bandi')
				.then(response => {
					this.bandi = response.data;
				})
				.finally(() => {
					this.isLoadingBandi = false;
				})
		},
		getTipiDiFatturazione() {
			this.isLoadingTipiDiFatturazione = true;
			axios('/api/accordi/tipi-di-fatturazione')
				.then(response => {
					this.tipiDiFatturazione = response.data;
				})
				.finally(() => {
					this.isLoadingTipiDiFatturazione = false;
				})
		},
		getAccountManagers() {
			this.isLoadingAccountManagers = true;
			return axios.get('/api/account-managers')
				.then(response => {
					this.accountManagers = response.data;
				})
				.finally(() => {
					this.isLoadingAccountManagers = false;
				})
		},
		async getAccordoPrenotazione() {
			this.isLoadingAccordoPrenotazione = true;
			this.files.accordo_prenotazione = await this.getFile(this.accordo.path_accordo_prenotazione);
			this.files.accordo_prenotazione.changed = false;
			this.isLoadingAccordoPrenotazione = false;
		},
		store() {
			if (!this.$refs.accordoForm.validate()) return
			this.isSaving = true;
			let formData = new FormData();
			for (let key in this.files) {
				formData.append(`files[${key}]`, this.files[key]);
			}
			formData.append('accordo', JSON.stringify(this.accordo));
			axios.post('/api/accordi', formData, {
				headers: { 'Content-Type': 'multipart/form-data' }
			})
				.then(response => {
					this.showSnackbar({
						color: 'success',
						message: this.generalSuccessMessage
					})
					this.$emit('close');
					this.$emit('reload-accordi');
				})
				.finally(() => {
					this.isSaving = false;
				})
		},
		update() {
			if (!this.$refs.accordoForm.validate()) return
			this.isSaving = true;
			let formData = new FormData();
			for (let key in this.files) {
				if (this.files[key] !== null) {
					if (this.files[key].hasOwnProperty('changed')) {
						// faccio append solo se durante la modifica dell'accordo si è scelto di sostituire il file attuale
						if (this.files[key].changed) formData.append(`files[${key}]`, this.files[key]);
					}
				}
			}
			
			formData.append('accordo', JSON.stringify(this.accordo));
			axios.patch(`/api/accordi/${this.accordo.id}`, formData, {
				headers: { 'Content-Type': 'multipart/form-data' }
			})
				.then(response => {
					this.showSnackbar({
						color: 'success',
						message: this.generalSuccessMessage
					})
					this.$emit('close');
					this.$emit('reload-accordi');
				})
				.finally(() => {
					this.isSaving = false;
				})
		},
		close() {
			this.$emit('close');
		},
		setChanged(file) {
			if (file !== null && !this.isLoading) file.changed = true;
		},
		openNotesDialog() {
			this.notesKey++;
			this.notesDialog = true;
		}
	}
}
</script>

<style scoped>

</style>